import {
  Governmental,
  NonGovernmental,
  Reporter,
  Suspect,
  Victim,
  Witness,
} from "types";
import apiClient from "../lib/apiClients";

// REPORTER
export const fetchReporter = async () => {
  const response = await apiClient.get<Reporter[]>("/legal-entity/reporters/");
  return response.data;
};
export const addReporter = async (reporter: Reporter) => {
  const response = await apiClient.post("/legal-entity/reporters/", reporter, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editReporter = async (reporter: Reporter) => {
  const response = await apiClient.put(
    "/legal-entity/reporters/" + reporter?.uu_id + "/",
    reporter,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const deleteReporter = async (reporter: Reporter) => {
  const response = await apiClient.delete(
    "/legal-entity/reporters/" + reporter?.uu_id + "/"
  );
  return response.data;
};

// SUSPECT
export const fetchSuspect = async () => {
  const response = await apiClient.get<Suspect[]>("/legal-entity/suspects/");
  return response.data;
};
export const fetchSuspectByInvestigation = async (cr_number: string) => {
  const response = await apiClient.get<Suspect[]>(
    `/legal-entity/suspects/?cr_number=${cr_number}`
  );
  return response.data;
};
export const fetchSuspectByIncidentRegistrationNumber = async (
  incident_registration_number: string
) => {
  const response = await apiClient.get<Suspect[]>(
    `/legal-entity/suspects/?incident_registration_number=${incident_registration_number}`
  );
  return response.data;
};
// Where each suspect stands, investigation up to cassation, keyed by uu_id.
export const fetchSuspectJourneys = async (
  incident_registration_number: string
) => {
  const response = await apiClient.get<Record<string, any[]>>(
    "/legal-entity/suspects/journeys/",
    { params: { incident_registration_number } }
  );
  return response.data;
};
// Every recorded decision about one suspect, registration up to cassation.
export const fetchSuspectHistory = async (suspectId: string) => {
  const response = await apiClient.get(
    `/legal-entity/suspects/${suspectId}/history/`
  );
  return response.data;
};
export const addSuspect = async (suspect: Suspect) => {
  const response = await apiClient.post("/legal-entity/suspects/", suspect, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editSuspect = async (suspect: Suspect) => {
  const response = await apiClient.patch(
    "/legal-entity/suspects/" + suspect?.uu_id + "/",
    suspect,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editSuspect2 = async (suspect: any) => {
  const response = await apiClient.patch(
    "/legal-entity/suspects/" + suspect?.uu_id + "/",
    suspect
  );
  return response.data;
};
export const deleteSuspect = async (suspect: Suspect) => {
  const response = await apiClient.delete(
    "/legal-entity/suspects/" + suspect?.uu_id + "/"
  );
  return response.data;
};

// VICTIM
export const fetchVictim = async () => {
  const response = await apiClient.get<Victim[]>("/legal-entity/victims/");
  return response.data;
};
export const fetchVictimByInvestigation = async (cr_number: string) => {
  const response = await apiClient.get<Victim[]>(
    `/legal-entity/victims/?cr_number=${cr_number}`
  );
  return response.data;
};
export const fetchVictimByIncidentRegistrationNumber = async (
  incident_registration_number: string
) => {
  const response = await apiClient.get<Victim[]>(
    `/legal-entity/victims/?incident_registration_number=${incident_registration_number}`
  );
  return response.data;
};
export const addVictim = async (victim: Victim) => {
  const response = await apiClient.post("/legal-entity/victims/", victim, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editVictim = async (victim: Victim) => {
  const response = await apiClient.put(
    "/legal-entity/victims/" + victim?.uu_id + "/",
    victim,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const deleteVictim = async (victim: Victim) => {
  const response = await apiClient.delete(
    "/legal-entity/victims/" + victim?.uu_id + "/"
  );
  return response.data;
};

// GOVERNMENTAL
export const fetchGovernmental = async () => {
  const response = await apiClient.get<Governmental[]>(
    "/legal-entity/governmentals/"
  );
  return response.data;
};
export const fetchGovernmentalByInvestigation = async (cr_number: string) => {
  const response = await apiClient.get<Governmental[]>(
    `/legal-entity/governmentals/?cr_number=${cr_number}`
  );
  return response.data;
};
export const fetchGovernmentalByIncidentRegistrationNumber = async (
  incident_registration_number: string
) => {
  const response = await apiClient.get<Governmental[]>(
    `/legal-entity/governmentals/?incident_registration_number=${incident_registration_number}`
  );
  return response.data;
};
export const addGovernmental = async (governmental: Governmental) => {
  const response = await apiClient.post(
    "/legal-entity/governmentals/",
    governmental
  );
  return response.data;
};
export const editGovernmental = async (governmental: Governmental) => {
  const response = await apiClient.put(
    "/legal-entity/governmentals/" + governmental?.uu_id + "/",
    governmental
  );
  return response.data;
};
export const deleteGovernmental = async (governmental: Governmental) => {
  const response = await apiClient.delete(
    "/legal-entity/governmentals/" + governmental?.uu_id + "/"
  );
  return response.data;
};

// NON-GOVERNMENTAL
export const fetchNonGovernmental = async () => {
  const response = await apiClient.get<NonGovernmental[]>(
    "/legal-entity/non-governmentals/"
  );
  return response.data;
};
export const fetchNonGovernmentalByInvestigation = async (
  cr_number: string
) => {
  const response = await apiClient.get<NonGovernmental[]>(
    `/legal-entity/non-governmentals/?cr_number=${cr_number}`
  );
  return response.data;
};
export const fetchNonGovernmentalByIncidentRegistrationNumber = async (
  incident_registration_number: string
) => {
  const response = await apiClient.get<NonGovernmental[]>(
    `/legal-entity/non-governmentals/?incident_registration_number=${incident_registration_number}`
  );
  return response.data;
};
export const addNonGovernmental = async (governmental: NonGovernmental) => {
  const response = await apiClient.post(
    "/legal-entity/non-governmentals/",
    governmental
  );
  return response.data;
};
export const editNonGovernmental = async (governmental: NonGovernmental) => {
  const response = await apiClient.put(
    "/legal-entity/non-governmentals/" + governmental?.uu_id + "/",
    governmental
  );
  return response.data;
};
export const deleteNonGovernmental = async (governmental: NonGovernmental) => {
  const response = await apiClient.delete(
    "/legal-entity/non-governmentals/" + governmental?.uu_id + "/"
  );
  return response.data;
};

// WITNESS
export const fetchWitness = async () => {
  const response = await apiClient.get<Witness[]>("/legal-entity/witnesses/");
  return response.data;
};
export const fetchWitnessByInvestigation = async (cr_number: string) => {
  const response = await apiClient.get<Witness[]>(
    `/legal-entity/witnesses/?cr_number=${cr_number}`
  );
  return response.data;
};
export const fetchWitnessByIncidentRegistrationNumber = async (
  incident_registration_number: string
) => {
  const response = await apiClient.get<Witness[]>(
    `/legal-entity/witnesses/?incident_registration_number=${incident_registration_number}`
  );
  return response.data;
};
export const addWitness = async (witness: Witness) => {
  const response = await apiClient.post("/legal-entity/witnesses/", witness, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editWitness = async (witness: Witness) => {
  const response = await apiClient.put(
    "/legal-entity/witnesses/" + witness?.uu_id + "/",
    witness,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const deleteWitness = async (witness: Witness) => {
  const response = await apiClient.delete(
    "/legal-entity/witnesses/" + witness?.uu_id + "/"
  );
  return response.data;
};
